module.exports = __webpack_public_path__ + "img/Ekivolt_120X35.dd2d6232.png";